const config = {
	API_BASE_URI: "https://csp-uat-api.xbrancher.billjc.com/sh-purchases-service/",
	prefix: "https://xibeibk.oss-cn-qingdao.aliyuncs.com/",
	SALT: "xibei12321",
	PROGRAMME_LIST: [
		{ name: "减单", type: "MINUS_QTY" },
		{ name: "次日补货", type: "NEXT_DAY_REPLENISHMENT" },
		{ name: "当日补货", type: "SAME_DAY_REPLENISHMENT" },
		{ name: "其他", type: "OTHER" },
		{ name: "自行采购", type: "SELF_PROCUREMENT" },
		{ name: "处理顾客投诉", type: "HANDLE_CUSTOMER_COMPLAINTS" }
	],
	NAV_LIST: [
		{
			name: "待裁定",
			type: "WAIT_WITH_RULING",
			path: "/list_wait_with_ruling",
			page: ""
		},
		{
			name: "待确认",
			type: "WAIT_PROVIDER_CONFIRM",
			path: "/list_wait_provider_confirm",
			page: "2"
		},
		{
			name: "已确认",
			type: "ALREADY_CONFIRMED",
			path: "/list_already_confirmed",
			page: "3"
		},
		{
			name: "已驳回",
			type: "ALREADY_REJECTED",
			path: "/list_already_rejected",
			page: "4"
		}
	]
};
export { config };
